import { IoMdClose } from "react-icons/io";
import StandardConfirmationModal from "../standard-confirmation";
import { Box } from "@mui/material";
import { FC } from "react";

interface RestrictUserModalProps extends StandardModalProps {
  onConfirm: () => void;
  name?: string;
  loading: boolean;
  description?: string;
}

const RestrictUserModal: FC<RestrictUserModalProps> = ({
  open,
  onClose,
  onConfirm,
  name,
  loading,
  description,
}) => {
  return (
    <StandardConfirmationModal
      open={open}
      onClose={onClose}
      maxWidth="xs"
      onConfirm={onConfirm}
      icon={
        <Box
          sx={{
            backgroundColor: "#FFD8D6",
            width: "48px",
            height: "48px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            color: "rgba(234, 67, 52, 1)",
          }}
        >
          <IoMdClose size={30} />
        </Box>
      }
      title={`Restrict “${name}”`}
      description={`Are you sure you want to restrict this ${description}? This action cannot be undone.`}
      confirmButtonColor="error"
      confirmButtonTitle="Restrict"
      confirmButtonLoader={loading}
    />
  );
};

export default RestrictUserModal;
